import apiClient from '@src/api/clients';

const PLAN_URL = 'app1/facebook/local-plan/';
const LOCK_URL = 'app1/facebook/local-lock/';
const IMPORTS_URL = 'app1/local-ad-imports/';
const PAGE_URL = 'app1/facebook/local-page/';

/**
 * What a build would create. Pure on the server — writes nothing — so this is
 * safe to call on every change of the floor.
 */
export const fetchLocalPlan = (payload) =>
  apiClient.request({
    url: PLAN_URL,
    method: 'GET',
    payload,
  });

/**
 * Lock which cities get an ad set. Saves the plan only — nothing is created on
 * Facebook until ads publish.
 */
export const lockLocalPlan = (payload) =>
  apiClient.request({
    url: LOCK_URL,
    method: 'POST',
    payload,
  });

/** Batches of ads pushed in by the generator app. */
export const fetchLocalAdBatches = () =>
  apiClient.request({
    url: IMPORTS_URL,
    method: 'GET',
  });

/** Publish one batch's ads to Facebook. Defaults to a dry run. */
export const publishLocalAdBatch = (batchId, payload) =>
  apiClient.request({
    url: `${IMPORTS_URL}${batchId}/publish/`,
    method: 'POST',
    payload,
  });

/**
 * Choose the Page a client's local ads use (use_for_local: true) and/or set a
 * Page's nickname. Returns the refreshed page list.
 */
export const updateLocalPage = (payload) =>
  apiClient.request({
    url: PAGE_URL,
    method: 'POST',
    payload,
  });
